import React from "react";
// import Image from "next/image";
import {ExchangeValues} from "@/ui/Exchange/ExchangeValues/ExchangeValues";
import {numberWithCommas} from "@/lib/numberWithCommas/numberWithCommas";
import { formatWithSubscript } from "@/app/hooks/market/useFormatWithSubscript";
import Link from "next/link";
import Image from "next/image";

interface ExchangeProps {
    data: any
    counter: number,
    type?: "singlePage" | "market",
    path: string
}

export const Exchange: React.FC<ExchangeProps> = ({data, counter, path, type = "market"}) => {

    if (type === "singlePage") {
        return <div className="sm:w-auto w-[max-content] cursor-pointer  hover:bg-hr-slate-890 group pr-[10px]">
            <div
                className="sm:grid flex gap-[36px] grid-cols-3 sm:grid-cols-5 xl:grid-cols-8  items-center text-hr-gray-64 py-3  text-[12px] sm:text-sm xl:text-base ">
                <div
                    className=" group-hover:bg-hr-slate-890  md:z-0 md:relative min-w-[150px] col-span-1 sm:col-span-3  lg:col-span-1 xl:col-span-4  flex items-center gap-3">
                    <div className="flex items-center gap-3 cursor-pointer">
                        <p className="p-[6px] pl-[10px] text-[10px] font-semibold text-hr-gray-64">
                            {counter}
                        </p>
                        <div className="flex items-center gap-3 text-[12px]">
                            {" "}
                            {!path.includes("exchangeDetail") ? <Image
                                width={24}
                                height={24}
                                className="w-[24px] h-[24px] rounded-full bg-gray-800 "
                                src={data?.market?.logo}
                                alt="Binance"
                            /> : ''}
                            <div className="flex flex-row sm:items-center gap-[2px] w-[141px] sm:w-auto sm:gap-3 text-[12px] items-start">
                                <p className="font-semibold text-[12px] md:text-sm sm:max-w-[max-content]  sm:overflow-[none] overflow-hidden text-ellipsis sm:whitespace-normal whitespace-nowrap">{path.includes("exchangeDetail") ? data?.coinId : data?.market?.name}</p>
                                {data.tradeUrl && path.includes("exchangeDetail") ?
                                    <Link href={data?.tradeUrl} className="flex items-center" target="_blank">
                                        <p className="uppercase text-hr-gray-64/70 sm:mt-[6px] rounded-sm px-[6px] py-[2px] font-semibold bg-hr-slate-950 text-gray-300 text-[10px] max-w-[90px] line-clamp-1 text-ellipsis ">
                                            {data?.base}/{data?.target}
                                        </p>
                                        <svg className="ml-2  ml-3 hover:text-lime-500  cursor-pointer copy-address size-[10px] sm:size-[20px]"
                                             width="20" height="20" viewBox="0 0 512 512"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <g clipPath="url(#clip0_353_827)">
                                                <path
                                                    d="M512 53.3333V213.333H448V109.248L203.968 353.28L158.72 308.032L402.752 64H298.667V0H458.667C488.064 0 512 23.936 512 53.3333ZM341.333 448H64V181.333C64 175.445 68.7787 170.667 74.6667 170.667H234.667L298.667 106.667H74.6667C33.4933 106.667 0 140.16 0 181.333V512H405.333V213.333L341.333 277.333V448Z"
                                                    fill="white"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_353_827">
                                                    <rect width="512" height="512" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </Link>
                                    : data.tradeUrl &&
                                    <Link href={data?.tradeUrl} className="flex items-center" target="_blank">
                                        <p className="uppercase text-hr-gray-64/70 sm:mt-[6px] rounded-sm px-[6px] py-[2px] font-semibold bg-hr-slate-950 text-gray-300 text-[10px] max-w-[90px] line-clamp-1 text-ellipsis">
                                           {data?.target}
                                        </p>
                                    </Link>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="sm:w-auto w-[67px]">
                    {/* <p className="text-right">$ {data?.last}</p> */}
                    <p className="text-right" dangerouslySetInnerHTML={{ __html: `$${formatWithSubscript(data?.last)}` }}></p>
                </div>
                <p className="text-center">{data?.bidAskSpreadPercentage?.toFixed(2)}%</p>
                {/* <p className="text-center hidden lg:block">{path.includes("exchangeDetail") ? data?.trustScore : <p dangerouslySetInnerHTML={{ __html: `$${formatWithSubscript(data?.costToMoveDownUsd.toFixed(0))}` }}></p>}</p>
                <p className="text-center hidden lg:block">{path.includes("exchangeDetail") ? <p dangerouslySetInnerHTML={{ __html: `$${formatWithSubscript(data?.volume)}` }}></p> : <p dangerouslySetInnerHTML={{ __html: `$${formatWithSubscript(data?.costToMoveDownUsd.toFixed(0))}` }}></p>}</p> */}
                <p className="text-center hidden lg:block">{path.includes("exchangeDetail") ? data?.trustScore : `$${numberWithCommas(Number(data?.costToMoveDownUsd?.toFixed(0)))}`}</p>
                <p className="text-center hidden lg:block">${path.includes("exchangeDetail") ? numberWithCommas(Number(data?.volume)) : numberWithCommas(Number(data?.costToMoveUpUsd?.toFixed(0)))}</p>
            </div>
            <div className="w-full h-[1px] bg-gradient-to-r from-transparent via-white/10 to-transparent"></div>
        </div>
    }


    return (
        <div
            id="exchange-0"
            className="w-full cursor-pointer  hover:bg-hr-slate-890/50 group pr-[10px]"
        >
            <div
                className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-4 xl:grid-cols-7 items-center text-hr-gray-64 py-3  text-[12px] sm:text-sm xl:text-base  ">
                <div
                    className="md:bg-transparent z-20 md:z-0 md:relative  min-w-[150px] col-span-1 sm:col-span-2  lg:col-span-1 xl:col-span-4 flex items-center gap-3">
                    <div className="flex items-center gap-3 cursor-pointer">
                        <p className="p-[6px] pl-[10px] text-[10px] font-semibold text-hr-gray-64">
                            {counter}
                        </p>
                        <div className="flex items-center gap-3 text-[12px]">
                            <Image
                                width={28}
                                height={28}
                                src={type === "market" ? data?.image : data.market.logo}
                                alt="Binance icon"
                                className="w-[28px] object-cover h-[28px] rounded-full"
                            />
                            <p className="font-semibold text-[12px] sm:text-sm xl:text-base max-w-[90px] sm:max-w-fit text-ellipsis line-clamp-1 overflow-hidden">
                                {type === "market" ? data?.name : data.market.name}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="w-full ">
                    <p className="text-right pr-[24px] w-full exchange-TrustScore">
                        {data?.trustScore} <span>/10</span>
                    </p>
                </div>
                <ExchangeValues data={data}/>
            </div>
            <div className="w-full h-[1px] bg-gradient-to-r from-transparent via-white/10 to-transparent"></div>
        </div>
    );
}